<template>
  <div v-if="usp_data && usp_data.usp.length > 0" class="what-price-cover mt-2 d-flex flex-row">
    <i class="fa fa-info-circle pr-2" style="color: #aaa" />
    <a v-b-modal.what-price-cover-modal class="black link-style">
      {{ strings.what_price_cover.link_text }}
    </a>

    <!-- Modal (start) -->
    <b-modal
        id="what-price-cover-modal"
        :title="strings.what_price_cover.modal_title"
        scrollable
        centered
        ok-only
        :ok-title="strings.close"
        ok-variant="primary button blue-full"
      >
      <ul>
        <li v-for="(item, key) in usp_data.usp" :key="key" :class="key > 0 ? 'mt-2' : ''">
          {{ item.text }}
        </li>
      </ul>

      <div v-if="usp_data.payment_plans_text" v-html="usp_data.payment_plans_text" />

      <div
          v-if="usp_data.testimonial"
          class="testimonial"
          :style="getTestimonialBackground()"
        >
        <div class="testimonial-container">
          <div class="message mb-2" v-html="usp_data.testimonial.message" />
          - {{ usp_data.testimonial.name }}, {{ usp_data.testimonial.title }}
        </div>
      </div>
    </b-modal>
    <!-- Modal (end) -->
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'

export default {
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  props: [
    'uspData',
    'strings'
  ],
  data: () => ({}),
  methods: {
    getTestimonialBackground() {
      return this.usp_data.testimonial.picture
        ? `background-image: url('${this.usp_data.testimonial.picture}');`
        : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.what-price-cover {
  line-height: 1rem;
}
.testimonial {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: transparent;
  padding: 0;

  > .testimonial-container {
    background-color: rgba(0, 0, 0, 0.36);
    padding: 8.75rem 1.25rem 1.25rem;
    color: white;

    > .message {
      font-weight: bold;
    }
  }
}
</style>
